<!--
 * @Description: 别忘记了描述
 * @Author: 泰多
 * @LastEditors: 泰多
 * @Date: 2020-11-25 10:37:17
 * @LastEditTime: 2020-11-30 16:52:37
-->
<template>
  <div id="app">
    <router-view />
    <TheLogin v-if="vx_isShowLogin" />

    <!-- 控制页面是否能继续访问 -->
    <td-global-hint-layer></td-global-hint-layer>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import TheLogin from '@/components/TheLogin'
// 控制页面是否能继续访问
import TdGlobalHintLayer from '@/components/TdGlobalHintLayer'
import { getHomePageGrayingInfos } from '@/service/api.js'


export default {
  components: {
    TheLogin,
    TdGlobalHintLayer
  },
  created() {
    // 刷新重新绑定token
    let storeMxToolToken = this.ut_getCookie()
    if (storeMxToolToken) {
      this.vx_setToken(storeMxToolToken)
      if (window.localStorage.getItem('mx_userInfo')) {
        this.vx_setUserInfo(JSON.parse(window.localStorage.getItem('mx_userInfo')))
      }
    } else {
      if (this.$route.path.indexOf('userCenter') != -1) {
        this.$router.push('/')
      }
    }
    this.fn_pageGray();
  },
  computed: {
    ...mapState(['vx_isShowLogin'])
  },
  watch: {
    $route(to) {
      let storeMxToolToken = this.ut_getCookie()
      if (to.path.indexOf('userCenter') != -1 && !storeMxToolToken) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    ...mapMutations(['vx_setToken', 'vx_setUserInfo']),
    //读取cookies
    ut_getCookie() {
      if (!document.cookie) return
      let arr_cookie = document.cookie.split(';')
      let reslut = arr_cookie.filter(
        item => item.indexOf('mx_token=') != -1 && item.length > 20 && item.length < 110
      )
      return reslut.length ? reslut[0].split('=')[1] : ''
    },
    // 系统控制
    async fn_pageGray() {
       let {isOk, data} =  await getHomePageGrayingInfos();
       if (isOk && data) {
         document.body.className += ' body-gray';
       }
    }
  }
}
</script>
<style>
.body-gray{
  -webkit-filter : grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
}
</style>
